import { useAppSelector } from "../redux/hooks";
import { formatDatamartFilters } from "../utils/formatV2DatamartFilters";
import { useFetch } from "./api";

const useSearchTermReport = (query, start, end, limit, dimensions, options = {}) => {
  const { marketPlace } = useAppSelector((state) => state.marketPlace);
  if (!dimensions) {
    dimensions = "query";
  }
  let filters = `date__gte:${start},date__lte:${end},marketplace:${marketPlace}`;
  if (query) {
    if (dimensions === "query") {
      filters = `${filters},query__icontains:${query}`;
    } else {
      filters = `${filters},keyword_text__icontains:${query}`;
    }

    if (options.overrideFilterType) {
      filters = `${filters},query__${options.overrideFilterType}:${query}`;
    }
  }

  let queryKeys = ["searchTermReport", start, end, query, limit, dimensions];

  if (options.additionalFilters) {
    const additionalFiltersString = formatDatamartFilters(options.additionalFilters);
    filters = `${filters},${additionalFiltersString}`;
  }

  if (options.additionalQueryKeys) {
    if (typeof options.additionalQueryKeys === "object") {
      queryKeys = [...queryKeys, ...options.additionalQueryKeys];
    } else {
      queryKeys.push(options.additionalQueryKeys);
    }
  }
  if (options?.category) {
    queryKeys.push(options.category);
    filters = `${filters},category_id:${options.category}`;
  }

  return useFetch(
    queryKeys,
    `/api/data_report_v2/searchtermreport/stats/`,
    {
      dimensions,
      filters,
      sort: options.sort ? options.sort : "-impressions",
      limit: limit,
    },
    {
      default: [],
      enabled: !!start && !!end,
      staleTime: 1000 * 60 * 5,
      select: (res) => res.data,
    },
  );
};

export default useSearchTermReport;
